module.exports = __webpack_public_path__ + "assets/AngleTrisection54.ffc7ef5f288aa2f77fb8dc5d91ae1e6c.gmt";


//////////////////
// WEBPACK FOOTER
// ./src/resources/levels/Gmt/AngleTrisection54.gmt
// module id = 901
// module chunks = 0